// extracted by mini-css-extract-plugin
module.exports = {"style":"_1eVp1YnA"};